import { motion, useReducedMotion } from 'framer-motion';
import { SongItem } from './SongItem';

export function RowSkeleton() {
  return (
    <div className="flex animate-pulse items-center gap-3 rounded-md bg-lounge-card/60 p-2">
      <div className="aspect-square w-14 shrink-0 rounded bg-lounge-raised" />
      <div className="flex flex-1 flex-col gap-2">
        <div className="h-3 w-2/3 rounded bg-lounge-raised" />
        <div className="h-3 w-1/3 rounded bg-lounge-raised" />
      </div>
    </div>
  );
}

function Message({ children, tone = 'text-lounge-stone' }) {
  return <p className={`py-6 text-center font-inter text-sm ${tone}`}>{children}</p>;
}

export function SearchResults({ results, stagedUris, canAdd, onAdd, error, loading, hasSearched }) {
  const reduce = useReducedMotion();

  if (error) return <Message tone="text-stop-soft">{error}</Message>;

  if (loading) {
    return (
      <div className="flex flex-col gap-2" aria-busy="true">
        {[0, 1, 2].map((i) => <RowSkeleton key={i} />)}
      </div>
    );
  }

  if (results.length === 0) {
    return hasSearched ? <Message>No encontramos canciones con ese nombre</Message> : null;
  }

  return (
    <div className="flex flex-col gap-2">
      {results.map((song, i) => (
        <motion.div
          key={song.uri}
          initial={reduce ? false : { opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: reduce ? 0 : Math.min(i, 8) * 0.04, duration: 0.3, ease: 'easeOut' }}
        >
          <SongItem song={song} staged={stagedUris.has(song.uri)} canAdd={canAdd} onAdd={onAdd} />
        </motion.div>
      ))}
    </div>
  );
}
